import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { AuthHeader } from "../../components/AuthHeader";
import authApi from "../../../../api/authApi";

const ForgotPassword: React.FC = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [error, setError] = useState<string | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);
        setIsSubmitting(true);

        try {
            await authApi.requestPasswordReset(email);
            localStorage.setItem("email", email);
            navigate("/reset-password-confirmation");
        } catch (err: any) {
            console.error("Reset request failed:", err);
            setError("Something went wrong. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="flex flex-col min-h-screen bg-gray-50">
            <AuthHeader />
            <div className="flex flex-col items-center flex-1 bg-gray-50 p-5">
                <div className="bg-white sm:w-2/5 max-w-xl py-10 px-8 rounded-lg shadow-sm">
                    <h1 className="text-2xl font-bold text-gray-800 text-center mb-6">
                        Reset Password</h1>
                    <p className="text-base font-medium text-gray-800 text-center mb-8">
                        Enter your email to get a password reset link.
                    </p>

                    <form onSubmit={handleSubmit} className="flex flex-col items-center gap-4">
                        {/* Email Input */}
                        <div className="w-full">
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                                Email
                            </label>
                            <input
                                id="email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="w-full h-12 px-4 border rounded-md bg-gray-100 text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter your email"
                                required
                            />
                        </div>

                        {error && (
                            <div className="w-full text-sm text-red-600 text-left">
                                {error}
                            </div>
                        )}

                        {/* Submit Button */}
                        <button
                            type="submit"
                            disabled={!email || isSubmitting}
                            className={`w-full button-1 ${email ? "bg-gray-800 hover:bg-gray-700" : "!bg-gray-400 !cursor-not-allowed"
                                }`}
                        >
                            {isSubmitting ? "Sending..." : "Send reset link"}
                        </button>

                        {/* Back to Login */}
                        <button
                            type="button"
                            onClick={() => navigate("/")}
                            className="flex items-center mt-6 text-gray-700 font-medium text-sm hover:text-gray-900 transition-colors"
                        >
                            <ChevronLeft className="w-4 h-4 mr-1" />
                            Back to login
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
